/** Mirrors backend ContentReportStatus (SadeceBilgisayar.DATA.Entities.Business). */
export enum ContentReportStatus {
  Pending = 0,
  Resolved = 1,
  Dismissed = 2,
}
